import styled from "styled-components";


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const ClickableText = styled.span`
  text-decoration: underline;
  margin: 0 0.25rem;
  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.primaryPurple.main};
  }
`;
